/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import { debounce } from '../../api/apiUtils';
import AppLink from '../../shared/components/app-link/AppLink';
import { NAVIGATION_ROUTES } from '../../shared/constants/Constants';

function CreditDebitList({ creditDebitList }) {
  const [searchText, setSearchText] = useState('');
  const [transactionsList, setTransactionsList] = useState([]);
  useEffect(() => {
    setTransactionsList(creditDebitList);
  }, [creditDebitList]);
  console.log(creditDebitList);

  const setSearchResults = debounce((val) => {
    if (creditDebitList.length > 0) {
      let data = [...creditDebitList];
      if (val !== '') {
        data = data.filter((o) =>
          Object.keys(o).some(
            (k) =>
              o[k] !== null &&
              o[k] !== undefined &&
              o[k].toString().toLowerCase().includes(val.toLowerCase()),
          ),
        );
      }
      setTransactionsList(data);
    }
  }, 500);

  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchText(value);
    setSearchResults(value);
  };

  const getReceipt = (txid) => {
    let route = NAVIGATION_ROUTES.CREDIT_DEBIT_NOTE;
    route = route.replace(':transactionId', txid);
    return route;
  };
  console.log(transactionsList, 'transaction liste ');
  return (
    <section className="credit-debit-list">
      <div className="credit-debit-list_container">
        <div className="m-3 d-flex">
          <div style={{ width: '300px' }}>
            <AppTextInput
              value={searchText}
              label="search"
              onChange={handleSearch}
            />
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th>TxId</th>
              <th>TxDate</th>
              <th>Amount</th>
              <th>Remarks</th>
              <th>Towards</th>
              <th>ReferenceId</th>
              <th>Select</th>
            </tr>
          </thead>
          <tbody>
            {transactionsList.map((transaction) => (
              <tr key={transaction.Txid}>
                <td className="background-color">{transaction.Txid}</td>
                <td>{transaction.TxDate}</td>
                <td>{transaction?.Amount?.toFixed(1)}</td>
                <td>{transaction.Remarks}</td>
                <td>{transaction.Towards}</td>
                <td>{transaction.ReferenceId}</td>
                <td>
                  <AppLink
                    linkText="Details"
                    isLink
                    href={getReceipt(transaction.Txid)}
                    target="_blank"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}

CreditDebitList.propTypes = {
  creditDebitList: PropTypes.array.isRequired,
};

export default CreditDebitList;
